
<template>
    <div class="center">
        <vs-dialog prevent-close v-model="active" @close="active = false" width="800px">
            <template #header>
                <h4 class="not-margin">
                    Vincular familiares desde el SIM
                </h4>
            </template>
            <div class="con-form" ref="content">
                <div v-if="buscandoShow" class="text-center">
                    <md-progress-bar md-mode="indeterminate"></md-progress-bar>
                    <h5 class="mt-2">Buscando</h5>
                </div>
                <vs-row v-if="!noFamiliaresSim">
                    <vs-col class="d-flex cardFamiliar" w="12" v-for="(padres, p) in familiaresSim.familiares" :key="p + 1" v-if="padres.fullName">
                        <vs-row style="align-items: center">
                            <vs-col w="2" class="px-2">
                                <vs-button @click="getVincularFamiliar(padres, familiaresSim)" v-if="!padres.duplicado_en_sigem" flat class="m-auto">
                                    <i class="fas fa-user-plus mr-1"></i> Agregar
                                </vs-button>
                                <p class="text-center mb-0" v-else><strong>VINCULADO</strong></p>
                            </vs-col>
                            <vs-col w="10" class="familiar">
                                <md-chip class="mini-chip text-uppercase mb-1" :class="padres.parentesco == 'padre' ? 'col-blue' : 'col-pink'"><small><strong> {{padres.parentesco}}</strong></small></md-chip>
                                <p class="mb-0"><strong>{{padres.fullName}}</strong></p>
                                <div class="d-flex justify-content-between">
                                    <p class="mb-0"><i class="far fa-envelope mr-2"></i>{{padres.correo}}</p>
                                    <p class="mb-0"><i class="fas fa-mobile-alt mr-2"></i>{{padres.celular}}</p>
                                </div>
                            </vs-col>
                        </vs-row>
                    </vs-col>
                    <vs-col class="cardFamiliar" w="12" v-for="(hermano, h) in familiaresSim.hermanos" :key="h">
                        <vs-row style="align-items: center">
                            <vs-col w="2" class="px-2">
                                <p class="text-center mb-0"><strong>HERMANO A VINCULAR</strong></p>
                            </vs-col>
                            <vs-col w="10" class="familiar">
                                <md-chip class="mini-chip text-uppercase mb-1 col-yellow"><small><strong>Hermano</strong></small></md-chip>
                                <p class="mb-1"><strong>{{hermano.fullName}}</strong></p>
                                <p class="mb-0"><small>MATRÍCULA: </small><strong>{{hermano.matricula}}</strong></p>
                            </vs-col>
                        </vs-row>
                    </vs-col>
                </vs-row>
                <h6 class="text-center">{{noFamiliaresSim}}</h6>
            </div>
        </vs-dialog>
    </div>
</template>
<script>
import accesibilidad from '../../../../../api/requests/accesibilidad.js'
export default {
    props:[
      'value',
      'info'
    ],
    data:() => ({
        active: false,
        familiaresSim: [],
        noFamiliaresSim: '',
        buscandoShow: true
    }),
    methods:{
        async getFamiliaresReferencia(){
            try {
                this.noFamiliaresSim = ''
                const params={
                    referencia_sim: this.info.referencia_sim
                }
                const response = await accesibilidad.getFamiliaresReferencia(params)
                this.buscandoShow = false
                this.familiaresSim = response.data
            }
            catch(error){
                this.buscandoShow = false
                this.noFamiliaresSim = error.response.data.message
            }
        },
        async getVincularFamiliar(info, familia){
            try {
                const params={
                    "familiar_sim_id": info.familiar_sim_id,
                    "familiar_sigem_id": info.familiar_sigem_id,
                    "parentesco": info.parentesco,
                    "persona_id_hermanos": [
                    "28907"
                    ]
                }
                const idHermano = []
                familia.hermanos.forEach(i => {
                    idHermano.push(i.persona_id)
                })
                params.persona_id_hermanos = idHermano
                const response = await accesibilidad.getVincularFamiliar(params)
                this.$vs.notification({
                    progress: 'auto',
                    color: 'success',
                    position: null,
                    title: 'Vinculación éxitosa',
                    text: 'El familiar ha sido vinculado correctamente.'
                })
                this.active = false
                this.$emit('refreshTable')
            }
            catch(error){
                this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    position: null,
                    title: 'Algo salió mal',
                    text: 'Favor de ponerse en contacto con el administrador.'
                })
            }
        },
    },
    watch:{
        value (val) {
            this.active = val
        },
        info(){
            this.getFamiliaresReferencia()
        },
        async active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
    }
}
</script>

 
<style>
.listAlumno{
    height: 200px;
    overflow: auto;
}
.listAlumno::-webkit-scrollbar {
    -webkit-appearance: none;
}

.listAlumno::-webkit-scrollbar:vertical {
    width:10px;
}

.listAlumno::-webkit-scrollbar-button:increment,.listAlumno::-webkit-scrollbar-button {
    display: none;
} 

.listAlumno::-webkit-scrollbar:horizontal {
    height: 10px;
}

.listAlumno::-webkit-scrollbar-thumb {
    background-color: #c0c0c0;
    border-radius: 20px;
    border: 2px solid #f1f2f3;
}

.listAlumno::-webkit-scrollbar-track {
    border-radius: 10px;  
}

.listAlumno .list-group-item{
    padding: 0 !important;   
    padding: 8px 6px !important; 
}

.parentesco{
    height: 50px; 
    display: flex; 
    justify-content: center;
    align-items: center; 
    color: white;
}


</style>

<style lang="scss" scoped>

    .tache{
        position: absolute;
        cursor: pointer;
        top: 30px;
        @media only screen and (max-width: 768px) {
            left: calc(95% - 4em);
        }
        @media only screen and (min-width: 768px) {
            left: calc(98% - 2em);
        }
    }

    .miniTarjetas{
        width: 96%;
        margin: 4% 4% 0 4%;
        border: 1px solid #e6e6e6;
        border-radius: 5px;
        padding: 5px 8px;
        min-height: 75px;
    }
    
        
    .divisionLineas:not(:last-child){
        border-bottom: 1px solid #E5E7E9; 
    }
    .divisionLineas{
        padding: 2% 0;
    }
    .col-blue{
        color: #2874A6;
        background: rgb(214, 234, 248);
    }
    .col-pink{
        color: #F08080;
        background: rgb(255, 236, 236);
    }
    .col-yellow{
        background: rgb(255, 248, 236);
        color: #febf3d;
    }
    .cardFamiliar{
        margin: 5px 0;
        padding: 10px;
        border: 1px solid #e6e6e6;
        border-radius: 7px;
    }
    .familiar{

       .md-chip{
           height: 25px;
           line-height: 25px
       } 
    }
</style>